/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverrideEmployeeAttendanceRequest
 */
export interface OverrideEmployeeAttendanceRequest {
    /**
     * 
     * @type {Date}
     * @memberof OverrideEmployeeAttendanceRequest
     */
    clockIn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OverrideEmployeeAttendanceRequest
     */
    clockOut?: Date;
    /**
     * 
     * @type {string}
     * @memberof OverrideEmployeeAttendanceRequest
     */
    reason: string;
}

/**
 * Check if a given object implements the OverrideEmployeeAttendanceRequest interface.
 */
export function instanceOfOverrideEmployeeAttendanceRequest(value: object): value is OverrideEmployeeAttendanceRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function OverrideEmployeeAttendanceRequestFromJSON(json: any): OverrideEmployeeAttendanceRequest {
    return OverrideEmployeeAttendanceRequestFromJSONTyped(json, false);
}

export function OverrideEmployeeAttendanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideEmployeeAttendanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clockIn': json['clockIn'] == null ? undefined : (new Date(json['clockIn'])),
        'clockOut': json['clockOut'] == null ? undefined : (new Date(json['clockOut'])),
        'reason': json['reason'],
    };
}

export function OverrideEmployeeAttendanceRequestToJSON(json: any): OverrideEmployeeAttendanceRequest {
    return OverrideEmployeeAttendanceRequestToJSONTyped(json, false);
}

export function OverrideEmployeeAttendanceRequestToJSONTyped(value?: OverrideEmployeeAttendanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clockIn': value['clockIn'] == null ? undefined : ((value['clockIn']).toISOString()),
        'clockOut': value['clockOut'] == null ? undefined : ((value['clockOut']).toISOString()),
        'reason': value['reason'],
    };
}

